import React from 'react';
import { Box, Flex, Spacer, Button, Heading, useColorModeValue } from '@chakra-ui/react';
import { Link } from 'react-router-dom'; // Assuming react-router-dom is used for navigation

const HomeNavbar = () => {
  const bgColor = useColorModeValue('gray.100', 'gray.900');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Box bg={bgColor} px={4} boxShadow="md">
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
        <Heading size="md" color={textColor}>Codeqlik</Heading>
        <Spacer />
        <Box>
          <Button as={Link} to="/login" colorScheme="teal" variant="solid">
            Login
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default HomeNavbar; 